import { ProductOption } from '../../shared/models/product-option.model';
import { SelectProductFormControls } from '../form-controls/select-product.form-controls';
import { SelectProductFormOptions } from '../form-options/select-product.form-options';
import { BaseForm } from './base.form';

export class DashboardProductForm extends BaseForm<SelectProductFormControls> {
  barcodeExists = false;
  canBeChanged = true;
  formGroup = this.createFormGroup(SelectProductFormControls);
  override options = new SelectProductFormOptions();

  get barcode(): string | null {
    return this.controls.barcode.value;
  }

  get inStockProductOptions(): ProductOption[] {
    return this.options.products.filter(product => product.inStock);
  }

  override clear(): void {
    super.clear();
    this.barcodeExists = false;
  }

  disable(): void {
    this.controls.barcode.disable();
    this.controls.product.disable();
  }

  enable(): void {
    if (this.canBeChanged) {
      this.controls.barcode.enable();
      this.controls.product.enable();
    }
  }
}
